module.exports = __webpack_public_path__ + "static/media/odd_favicon_2.50edd3b6.png";